module.exports = __webpack_public_path__ + "resources/img/29100.ebfa27f4a86cb9062983ada63a7ea4f8.png";